import { render, staticRenderFns } from "./PinBatchList.vue?vue&type=template&id=858a873a&"
import script from "./PinBatchList.vue?vue&type=script&lang=js&"
export * from "./PinBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports